import apiService from "./apiService";

const PREFIX = "/packages";

export const packageService = {
  getPackages,
};

function getPackages() {
  return apiService.get(`${PREFIX}/names`);
}
